import React, { FC } from 'react'
import { GotoMembrsearchModal } from '../GotoMembrsearchModal'
import { SignupMemberModal } from '../SignupMemberModal'

interface HeaderLinksProps {
    showGotoMembrsearchModal?: boolean
}

const HeaderLinks: FC<HeaderLinksProps> = ({ showGotoMembrsearchModal }) => {
    return (
        <>
            {showGotoMembrsearchModal ? <GotoMembrsearchModal /> : null}
            <SignupMemberModal />
        </>
    )
}

HeaderLinks.defaultProps = {
    showGotoMembrsearchModal: true,
}

export { HeaderLinks }
